import { SystemField } from "./system-field";

export class Photo  extends SystemField{
     
    parent_id?:string;
    ordering?:string;
    thumbnail?:string;
    photo?:string;

    // Formula Fields
    photo_file?:string;
    photo_preview?:string;
    thumbnail_file?:string;
    thumbnail_preview?:string;
}
